<template>
  <v-container>
    <v-card>
      <v-card-title>
        <v-row>
          <v-col cols="12" sm="6" md="3">
            <v-menu
              ref="menu1"
              v-model="menu1"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              full-width
              max-width="400px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="startDateFormatted"
                  required
                  :rules="dateRules"
                  prepend-icon="event"
                  v-on="on"
                  @blur="start_date = parseDate(startDateFormatted)"
                  label="From Date"
                >
                </v-text-field>
              </template>
              <v-date-picker
                v-model="start_date"
                no-title
                @input="getPositions()"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <!-- <v-col cols="12" sm="6" md="3">
            <v-menu
              ref="menu2"
              v-model="menu2"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              full-width
              max-width="400px"
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="endDateFormatted"
                  required
                  :rules="dateRules"
                  prepend-icon="event"
                  v-on="on"
                  @blur="end_date = parseDate(endDateFormatted)"
                  label="To Date"
                >
                </v-text-field>
              </template>
              <v-date-picker
                v-model="end_date"
                no-title
                @input="getPositions()"
              ></v-date-picker>
            </v-menu>
          </v-col> -->
          <v-col cols="12" sm="6" md="3">
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
          <!-- <v-col cols="12" sm="6" md="3">
              <v-btn color="primary"  @click="createCSV()"><v-icon left dark>mdi-download</v-icon>Download</v-btn>
            </v-col> -->
        </v-row>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :fixed-header="true"
        :items="positions"
        :search="search"
        :options.sync="options"
        :server-items-length="totalItems"
        :footer-props="{
          'items-per-page-options': [10, 20, 30, 40, 50],
        }"
        :items-per-page="40"
        item-key="id"
        class="elevation-1"
        :loading="isLoading"
        loading-text="Loading... Please wait"
        :mobile-breakpoint="100"
      >
        <template v-slot:item.insert_date="{ item }">
          {{ getFormattedDate(item.insert_date) }}
        </template>
        <template v-slot:item.insert_time="{ item }">
          {{ getFormattedTime(item.insert_time) }}
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import axios from "axios";
import moment from "moment";
import jsonexport from "jsonexport/dist";
import { saveAs } from "file-saver";
import { mapState, mapGetter, mapActions } from "vuex";

export default {
  name: "auto_attach_rep",
  data() {
    return {
      csvurl: null,
      search: "",
      dateRules: [(v) => !!v || "Date is required"],
      start_date:
        this.curStartDate || moment().format("YYYY-MM-DD"),
      end_date: this.curEndDate || moment().format("YYYY-MM-DD"),
      startDateFormatted:
        this.curStartDate || moment().format("DD/MM/YYYY"),
      endDateFormatted: this.curEndDate || moment().format("DD/MM/YYYY"),
      menu1: false,
      menu2: false,
      page: 1,
      options: {},
      pageCount: 0,
      email: "",
      itemsPerPage: 1,
      totalItems: 0,
      errors: [],
      headers: [
        {
          text: "Date",
          align: "left",
          sortable: true,
          value: "insert_date",
        },
        {
          text: "Time",
          align: "left",
          sortable: true,
          value: "insert_time",
        },
        { text: "Msg Title", value: "msg_title" },
        { text: "Stn Code", value: "stn_code" },
        { text: "PF", value: "pf" },
        { text: "Msg", value: "msg" },
      ],
      position: {},
      positions: [],
      isLoading: false,
    };
  },
  created() {
    (this.start_date =
      this.curStartDate || moment().format("YYYY-MM-DD")),
      (this.end_date = this.curEndDate || moment().format("YYYY-MM-DD")),
      this.getPositions();

    // axios.defaults.headers.common['Authorization'] = localStorage.getItem('jwtToken')
    // axios.get(`${process.env.VUE_APP_API_URL}/timetable/tc/events`,{params: p})
    // .then(response => {
    // //  console.log(response.data);
    //   this.positions = response.data
    // //  this.csvurl = this.createCSV()
    // })
    // .catch(e => {
    //   this.errors.push(e)
    //   if(e.response.status === 401) {
    //     this.$router.push({
    //       name: 'Signin'
    //     })
    //   }
    // })
  },
  computed: {
    ...mapState(["curStartDate", "curEndDate"]),
    computedDateFormatted() {
      return this.formatDate(this.editItem.train_date);
    },
  },
  watch: {
    start_date(val) {
      this.startDateFormatted = this.formatDate(val);
    },
    end_date(val) {
      this.endDateFormatted = this.formatDate(val);
    },
      options: {
      handler () {
        this.getPositions()

          // .then(data => {
          //   this.desserts = data.items
          //   this.totalDesserts = data.total
          // })
      },
      // deep: true,
    },
    search: {
      handler() {
        this.getPositions()
        }
    }

  },
  methods: {
    ...mapActions(["updateCurStartDate", "updateCurEndDate"]),
    clear() {},
    formatDate(date) {
      if (!date) return null;
      return moment(date).format("DD/MM/YYYY");
    },
    parseDate(date) {
      if (!date) return null;
      return moment(date, ["DD/MM/YYYY"]).format("YYYY-MM-DD");
    },
    getPositions() {
      //      console.log(this.curDeviceId)
           this.menu1 = false;
     this.menu2 = false
      axios.defaults.headers.common["Authorization"] =
        localStorage.getItem("jwtToken");
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      console.log(this.search.length);
      var offset = 0;
      if (page > 1) {
        offset = (page - 1) * itemsPerPage;
      }
      var para = {
        start_date: this.start_date || moment().format("YYYY-MM-DD"),
        offset: offset,
        itemsPerPage: itemsPerPage || 40,
        page: page,
      };
      axios
        .get(`${process.env.VUE_APP_API_URL}/pf/pf_auto_msg`, { params: para })
        .then((response) => {
          console.log(response);
          this.positions = response.data;
          if (sortBy.length === 1 && sortDesc.length === 1) {
            this.positions = this.positions.sort((a, b) => {
              const sortA = a[sortBy[0]];
              const sortB = b[sortBy[0]];

              if (sortDesc[0]) {
                if (sortA < sortB) return 1;
                if (sortA > sortB) return -1;
                return 0;
              } else {
                if (sortA < sortB) return -1;
                if (sortA > sortB) return 1;
                return 0;
              }
            });
          }
        })
        .catch((e) => {
          this.errors.push(e);
          if (e.response.status === 401) {
            this.$router.push({
              name: "Login",
            });
          }
        });

      var para1 = {
        start_date: this.start_date || moment().format("YYYY-MM-DD"),
      };
      axios
        .get(`${process.env.VUE_APP_API_URL}/pf/count`, { params: para1 })
        .then((response) => {
          this.totalItems = parseInt(response.data[0].totalItems);
          console.log(this.totalItems);
        })
        .catch((e) => {
          this.errors.push(e);
          if (e.response.status === 401) {
            this.$router.push({
              name: "Login",
            });
          }
        });
      var para2 = {
        start_date: this.start_date || moment().format("YYYY-MM-DD"),
        search: this.search,
      };
      if (this.search.length != 0) {
        axios
          .get(`${process.env.VUE_APP_API_URL}/pf/search`, { params: para2 })
          .then((response) => {
            this.positions = response.data;
            if (sortBy.length === 1 && sortDesc.length === 1) {
              this.positions = this.positions.sort((a, b) => {
                const sortA = a[sortBy[0]];
                const sortB = b[sortBy[0]];

                if (sortDesc[0]) {
                  if (sortA < sortB) return 1;
                  if (sortA > sortB) return -1;
                  return 0;
                } else {
                  if (sortA < sortB) return -1;
                  if (sortA > sortB) return 1;
                  return 0;
                }
              });
            }
          })
          .catch((e) => {
            this.errors.push(e);
            if (e.response.status === 401) {
              this.$router.push({
                name: "Login",
              });
            }
          });
      }
    },
    round(value, precision) {
      var multiplier = Math.pow(10, precision || 0);
      return Math.round(value * multiplier) / multiplier;
    },

    getFormattedTime(t) {
      if (t !== "--") {
        var lt = moment(t);
        var localDate = moment(lt).local();
        return localDate.format("HH:mm:ss");
      }
    },
    getFormattedTimeSec(t) {
      if (t < 0) {
        return "-" + moment.utc(Math.abs(t) * 1000).format("HH:mm:ss");
      } else {
        return moment.utc(Math.abs(t) * 1000).format("HH:mm:ss");
      }
    },
    getFormattedDate(t) {
      return moment(t).format("DD/MM/YYYY");
    },
    createCSV() {
      // let csvContent = "data:text/csv;charset=utf-8,";
      // var filename = this.curStartDate + '-' + this.curEndDate + '.csv'
      // var ctr = []
      // for(var i=0; i <this.positions.length; i++ ) {
      //   ctr.push({
      //     srl_no: this.positions[i]['srl_no'],
      //     stn_code: this.positions[i]['stn_code'],
      //     sch_arr:  this.positions[i]['sch_arr'],
      //     sch_dep:  this.positions[i]['sch_dep'],
      //     act_arr: this.positions[i]['act_arr'],
      //     act_dep: this.positions[i]['act_dep'],
      //     late_in: this.positions[i]['late_in'],
      //     late_out: this.positions[i]['late_out'],
      //     stop_time: this.positions[i]['stop_time'],
      //     stn_enter_speed: this.positions[i]['geofence_enter_speed'],
      //     loss_gain_on_run: this.positions[i]['loss_gain_on_run_formatted'],
      //     sec_distance: this.positions[i]['sectional_dist'],
      //     sec_avg_speed: this.positions[i]['avg_speed'],
      //     sec_max_speed: this.positions[i]['sec_max_speed']
      //   })
      // }
      // ctr[0]['late_in'] = '--'
      // ctr[0]['sch_arr'] = '--'
      // ctr[0]['act_arr'] = '--'
      // ctr[0]['stop_time'] = '--'
      // ctr[0]['stn_enter_speed'] = '--'
      // ctr[this.positions.length-1]['late_out'] = '--'
      // ctr[this.positions.length-1]['sch_dep'] = '--'
      // ctr[this.positions.length-1]['act_dep'] = '--'
      // ctr[this.positions.length-1]['stop_time'] = '--'
      //
      // jsonexport(ctr,function(err, csv){
      //    if(err) return console.log(err);
      //    //console.log(csv);
      //    var blob = new Blob([csv], {
      //     type: "data:text/csv;charset=utf-8,"
      //    });
      //    saveAs(blob, filename);
      //   });
    },
    getColor(calories) {
      if (calories > 400) return "red";
      else if (calories > 200) return "orange";
      else return "green";
    },
  },
};
</script>
